import { dialogContentClasses } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useFreemiumWelcomeDialogStyles = makeStyles()(theme => ({
  paper: {
    width: 600,
    padding: 0,

    [`&& .${dialogContentClasses.root}`]: {
      padding: theme.spacing(8, 10, 10),
    },

    [theme.breakpoints.down('sm')]: {
      padding: 0,

      [`&& .${dialogContentClasses.root}`]: {
        padding: theme.spacing(5, 4),
      },
    },
  },
  closeButton: {
    top: 40,
    right: 40,

    backgroundColor: theme.palette.background.paper,

    borderRadius: theme.shape.borderRadiusMd,

    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },

    '&& svg': {
      color: theme.palette.text.secondary,
    },

    [theme.breakpoints.down('sm')]: {
      top: 16,
      right: 16,

      width: 32,
      height: 32,

      '&& svg': {
        fontSize: 20,
      },
    },
  },
  dialogTitle: {
    margin: 0,
  },
}));
